import React from 'react';

import { DialogContent } from '@mui/material';

import Links from 'MapManagement/GeneralSettings/Links';

const Integrate = ({ path }) => {
  return (
    <DialogContent>
      <Links map={path} type="manage" noTitle={true} />
    </DialogContent>
  );
};

export default Integrate;
